import React, { Component } from 'react';
import { Modal, message, Spin, InputNumber, Input, Radio, Icon, Upload, Button } from 'antd';
import $, { xToken } from '../../../common/AjaxRequest.js';
import API_URL from '../../../common/url.js';
import format from '../../shared/format.js';
import '../../clinicalEvaluation/clinicalEvaluationRecord/index.less';

const RadioGroup = Radio.Group;

class ConfirmTotalPiceModal extends Component {
    state = {
        params: {},
        record: {},
        visible: false,
        loading: false,
        priceParams: {},
        serveFeeType: '',
        fileList: [],
        talAuth: false,
    }

    show = (record, talAuth = false) => {
        this.setState({
            params: { ...record },
            visible: true,
            talAuth,
        },() => {
            this.queryEvaluateRecordBasePrice();
            this.loadData();
            this.queryServeFeeType();
        });
    }

    hide = () => {
        this.setState({
            params: {},
            visible: false,
            loading: false,
        });
    }

    queryServeFeeType = () => {
        const { params } = this.state;
        const { evaluateRecordId } = params;
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryServeFeeType,
            data: { evaluateRecordId },
            dataType: "json",
            doneResult: (res) => {
                const { serveFeeType } = res;
                this.setState({
                    serveFeeType,
                })
            },
        };
        $.sendRequest(options);
    }

    //获取项目基本信息数据
    loadData = () => {
        const { params } = this.state;
        const { evaluateRecordId } = params;
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryEvaluateServeCustomer,
            data: {
                evaluateRecordId,
            },
            dataType: "json",
            doneResult: (res) => {
                const { data: { evaluateRecordCustomer }} = res;
                params.startSiteNum = evaluateRecordCustomer.startSiteNum;
                this.setState({ params });
            },
        }
        $.sendRequest(options);
    }


    //获取建议底价数据
    queryEvaluateRecordBasePrice = () => {
        const { params: { evaluateRecordId } } = this.state;
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryEvaluateRecordBasePrice,
            data: { evaluateRecordId },
            dataType: "json",
            doneResult: (res) => {
                const { basePrice } = res;
                this.setState({
                    priceParams: basePrice ? basePrice : {}
                })
            },
        };
        $.sendRequest(options);
    }

    submit = () => {
        const { params, priceParams, serveFeeType } = this.state;
        const {
            evaluateRecordId,
            evaluateStatus,
            businessProposalTotalPrice,
            nonBindBusinessProposalTotalPrice,
            businessProposalRemark,
        } = params;
        const {
            evaluateRecordBasePriceId,
            suggestEvaluateUnitTaxPrice, 
            suggestEvaluateTotalTaxPrice,
            suggestInvestigationYearOutPutTax,
            nonBindSuggestEvaluateTotalTaxPrice,
            nonBindSuggestEvaluateUnitTaxPrice,
            nonBindSuggestInvestigationYearOutPutTax,
        } = priceParams;
        const isBind = serveFeeType === "BIND";  //项目包含盲态服务
        const isNonBind = serveFeeType === "NON_BIND";  //项目包含非盲服务
        const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";  //项目包含盲态服务和非盲服务
        if (evaluateStatus !== 'STATE_CONFIRM' && evaluateStatus !== 'STATE_FOR_RESTART_APPROVAL') {
            return message.warning('请选择总价申请结果');
        }

        if (isBind && evaluateStatus == 'STATE_FOR_RESTART_APPROVAL' && !businessProposalTotalPrice) {
            return message.warning('请输入商务建议总价金额(含税)/人民币');
        }
        if (isNonBind && evaluateStatus == 'STATE_FOR_RESTART_APPROVAL' && !nonBindBusinessProposalTotalPrice) {
            return message.warning('请输入商务建议总价金额(含税)/人民币');
        }
        if (isBindAndNonBind && evaluateStatus == 'STATE_FOR_RESTART_APPROVAL' && !businessProposalTotalPrice) {
            return message.warning('请输入盲态服务商务建议总价金额(含税)/人民币');
        }
        if (isBindAndNonBind && evaluateStatus == 'STATE_FOR_RESTART_APPROVAL' && !nonBindBusinessProposalTotalPrice) {
            return message.warning('请输入非盲服务商务建议总价金额(含税)/人民币');
        }
        if (evaluateStatus == 'STATE_FOR_RESTART_APPROVAL' && !businessProposalRemark) {
            return message.warning('请输入备注说明');
        }
        const sendParams = {
            evaluateRecordId,
            evaluateRecordBasePriceId,
            serveFeeType,
            evaluateStatus,
            businessProposalTotalPrice: evaluateStatus == 'STATE_CONFIRM' ? suggestEvaluateTotalTaxPrice : businessProposalTotalPrice,
            businessProposalUnitPrice: evaluateStatus == 'STATE_CONFIRM' ? suggestEvaluateUnitTaxPrice : undefined,
            businessProposalInvestigationYearOutPut: evaluateStatus == 'STATE_CONFIRM' ? suggestInvestigationYearOutPutTax : undefined,

            nonBindBusinessProposalTotalPrice: evaluateStatus == 'STATE_CONFIRM' ? nonBindSuggestEvaluateTotalTaxPrice : nonBindBusinessProposalTotalPrice,
            nonBindBusinessProposalUnitPrice: evaluateStatus == 'STATE_CONFIRM' ? nonBindSuggestEvaluateUnitTaxPrice : undefined,
            nonBindBusinessProposalInvestigationYearOutPut: evaluateStatus == 'STATE_CONFIRM' ? nonBindSuggestInvestigationYearOutPutTax : undefined,


            businessProposalRemark,
        };
        if (evaluateStatus == 'STATE_FOR_RESTART_APPROVAL') {
            Modal.confirm({
                iconType: 'question-circle',
                title: <div style={{marginLeft: 42}}>该报价单重新申请总价时填写的是“总价含税金额”，请确认数据填写是否有误（例如填写单例含税金额）</div>,
                okText: '发起申请',
                cancelText: '重新填写',
                onOk: () => {
                    this.confirmTotalPriceStatus(sendParams);
                },
            });
        } else {
            this.confirmTotalPriceStatus(sendParams);
        }
    }

    confirmTotalPriceStatus = sendParams => {
        const { fileList } = this.state;
        const fromData = new FormData();
        fromData.append('curUserId', sessionStorage.userId);
        fromData.append('curEmployeeCode', sessionStorage.curEmployeeCode || '');
        fileList.map((file, index) => {
            fromData.append(`files[${index}]`, file)
        });
        
        for (const key in sendParams) {
            if (sendParams[key] || sendParams[key] == 0) {
                fromData.append(`${key}`, sendParams[key]);
            }
        }
        this.setState({ loading: true });
        const url = API_URL.evaluate.confirmTotalPriceStatus;
        fetch(url, {
            method: 'post',
            body: fromData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                ...xToken,
            }
        }).then(res => {
            if (res.ok) {
                return res.json();
            }
        }).then(data => {
            if (data.error) {
                message.error(data.error);
                this.setState({ loading: false });
            } else {
                message.success(data.success);
                this.hide();
                this.props.loadData();
            }
        }).catch(err => {
            message.error(err);
            this.setState({ loading: false });
        });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    beforeUpload = (file) => {
        this.setState({
            fileList:[
                ...this.state.fileList,
                file,
            ]
        })
        return false
    }

    handleRemove = (file) => {
        const { fileList } = this.state;
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        this.setState({fileList: newFileList});
    }


    render() {
        const { visible, loading, params, priceParams, serveFeeType, fileList, talAuth } = this.state;
        const isBind = serveFeeType === "BIND";  //项目包含盲态服务
        const isNonBind = serveFeeType === "NON_BIND";  //项目包含非盲服务
        const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";  //项目包含盲态服务和非盲服务
        const { 
            evaluateCode,
            evaluateSerialNumber, 
            startSiteNum, 
            randomCaseNum,
            evaluateStatus,
            businessProposalRemark, 
            businessProposalTotalPrice,
            nonBindBusinessProposalTotalPrice,
        } = params;
        // if (isNonBind) {
        //     priceParams.suggestEvaluateUnitTaxPrice = priceParams.nonBindSuggestEvaluateUnitTaxPrice;
        //     priceParams.suggestEvaluateTotalTaxPrice = priceParams.nonBindSuggestEvaluateTotalTaxPrice;
        //     priceParams.suggestInvestigationYearOutPutTax = priceParams.nonBindSuggestInvestigationYearOutPutTax;
        // }

        const {
            whetherPushGpCalcuationValue,
            gpCalcuationValue,
            basePriceStatusName,
            suggestEvaluateUnitTaxPrice, 
            suggestEvaluateTotalTaxPrice,
            suggestInvestigationYearOutPutTax,
            nonBindSuggestEvaluateUnitTaxPrice,
            nonBindSuggestEvaluateTotalTaxPrice,
            nonBindSuggestInvestigationYearOutPutTax,
            remark,
        } = priceParams;
        const suggestEvaluateUnitTaxPriceValue = isBind ? 'suggestEvaluateUnitTaxPrice' : 'nonBindSuggestEvaluateUnitTaxPrice';
        const suggestEvaluateTotalTaxPriceValue = isBind ? 'suggestEvaluateTotalTaxPrice' : 'nonBindSuggestEvaluateTotalTaxPrice';
        const suggestInvestigationYearOutPutTaxValue = isBind ? 'suggestInvestigationYearOutPutTax' : 'nonBindSuggestInvestigationYearOutPutTax';
        const businessProposalTotalPriceValue = isBind ? 'businessProposalTotalPrice' : 'nonBindBusinessProposalTotalPrice';
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const { curRole }= sessionStorage;
        const showGpValue = (curRole == 'BD' || curRole == 'BA' || curRole == 'BDO' || curRole == 'BAL'|| curRole == 'BDM') ? !talAuth : true;
        return (
            <Modal
                title={'总价确认'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                maskClosable={false}
                confirmLoading={loading}
                width={600}
            >
                <Spin spinning={loading}>
                    <div className="apply_content" >
                        <div className="content_item" >
                            <div className="item_left" >临床评估单号：</div>
                            <div className="item_right">{evaluateCode}</div>
                        </div>
                        <div className="content_item" >
                            <div className="item_left" >方案编号：</div>
                            <div className="item_right">{evaluateSerialNumber}</div>
                        </div>
                        <div className="content_item" >
                            <div className="item_left" >建议报价方式：</div>
                            <div className="item_right">{basePriceStatusName}</div>
                        </div>
                        <div className="content_item" >
                            <div className="item_left" >启动中心数：</div>
                            <div className="item_right">{startSiteNum}</div>
                        </div>
                        <div className="content_item" >
                            <div className="item_left" >随机病例数：</div>
                            <div className="item_right">{randomCaseNum}</div>
                        </div>
                        {
                            showGpValue && <div className="content_item" >
                                <div className="item_left" >GP%：</div>
                                <div className="item_right">{gpCalcuationValue}%</div>
                            </div>
                        }
                        {(isBind || isNonBind) &&
                            <div className="content_item" >
                                <div className="item_left" >建议单例价格/金额(含税)/人民币：</div>
                                <div className="item_right">{ format('money', priceParams[suggestEvaluateUnitTaxPriceValue])}</div>
                            </div>
                        }
                        {(isBind || isNonBind) &&
                            <div className="content_item" >
                                <div className="item_left" >建议总价金额(含税)/人民币：</div>
                                <div className="item_right">{ format('money', priceParams[suggestEvaluateTotalTaxPriceValue])}</div>
                            </div>
                        }
                        {(isBind || isNonBind) &&
                            <div className="content_item" >
                                <div className="item_left" >建议项目年产出(含税)人民币：</div>
                                <div className="item_right">{ format('money', priceParams[suggestInvestigationYearOutPutTaxValue])}</div>
                            </div>
                        }

                        {isBindAndNonBind &&
                            <div className="content_item" >
                                <div className="item_left" >盲态服务建议单例价格/金额(含税)/人民币：</div>
                                <div className="item_right">{ format('money', suggestEvaluateUnitTaxPrice)}</div>
                            </div>
                        }
                        {isBindAndNonBind &&
                            <div className="content_item" >
                                <div className="item_left" >盲态服务建议总价金额(含税)/人民币：</div>
                                <div className="item_right">{ format('money', suggestEvaluateTotalTaxPrice)}</div>
                            </div>
                        }
                        {isBindAndNonBind &&
                            <div className="content_item" >
                                <div className="item_left" >盲态服务建议项目年产出(含税)人民币：</div>
                                <div className="item_right">{ format('money', suggestInvestigationYearOutPutTax)}</div>
                            </div>
                        }

                        {isBindAndNonBind &&
                            <div className="content_item" >
                                <div className="item_left" >非盲服务建议单例价格/金额(含税)/人民币：</div>
                                <div className="item_right">{ format('money', nonBindSuggestEvaluateUnitTaxPrice)}</div>
                            </div>
                        }
                        {isBindAndNonBind &&
                            <div className="content_item" >
                                <div className="item_left" >非盲服务建议总价金额(含税)/人民币：</div>
                                <div className="item_right">{ format('money', nonBindSuggestEvaluateTotalTaxPrice)}</div>
                            </div>
                        }
                        {isBindAndNonBind &&
                            <div className="content_item" >
                                <div className="item_left" >非盲服务建议项目年产出(含税)人民币：</div>
                                <div className="item_right">{ format('money', nonBindSuggestInvestigationYearOutPutTax)}</div>
                            </div>
                        }
                        
                        <div className="content_item" >
                            <div className="item_left" >建议底价情况说明：</div>
                            <div className="item_right"><span style={{ whiteSpace: 'normal' }}>{remark}</span></div>
                        </div>
                        <div className="content_item" >
                            <div className="item_left">{asterisk}总价申请结果：</div>
                            <div className="item_right">
                                <RadioGroup
                                    value={evaluateStatus}
                                    onChange={e => this.handleChange(e.target.value, 'evaluateStatus')}
                                >
                                    <Radio value={'STATE_CONFIRM'}>确认总价</Radio>
                                    <Radio style={{ marginLeft: '10px' }} value={'STATE_FOR_RESTART_APPROVAL'}>重新总价申请</Radio>
                                </RadioGroup>
                            </div>
                        </div>
                        {
                            ((isBind || isNonBind) && evaluateStatus == 'STATE_FOR_RESTART_APPROVAL') && <div className="content_item" >
                                <div className="item_left">{asterisk}商务建议总价金额(含税)/人民币：</div>
                                <div className="item_right">
                                    <InputNumber
                                        placeholder='请输入'
                                        step={0.01} 
                                        min={0} 
                                        precision={2}
                                        style={{ width: 200 }}
                                        value={params[businessProposalTotalPriceValue]}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                        onChange={value => this.handleChange(value, businessProposalTotalPriceValue)}
                                    />
                                </div>
                            </div>
                        }
                        {
                            (isBindAndNonBind && evaluateStatus == 'STATE_FOR_RESTART_APPROVAL') && <div className="content_item" >
                                <div className="item_left">{asterisk}盲态服务商务建议总价金额(含税)/人民币：</div>
                                <div className="item_right">
                                    <InputNumber
                                        placeholder='请输入'
                                        step={0.01} 
                                        min={0} 
                                        precision={2}
                                        style={{ width: 200 }}
                                        value={businessProposalTotalPrice}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                        onChange={value => this.handleChange(value, 'businessProposalTotalPrice')}
                                    />
                                </div>
                            </div>
                        }
                        {
                            (isBindAndNonBind && evaluateStatus == 'STATE_FOR_RESTART_APPROVAL') && <div className="content_item" >
                                <div className="item_left">{asterisk}非盲服务商务建议总价金额(含税)/人民币：</div>
                                <div className="item_right">
                                    <InputNumber
                                        placeholder='请输入'
                                        step={0.01} 
                                        min={0} 
                                        precision={2}
                                        style={{ width: 200 }}
                                        value={nonBindBusinessProposalTotalPrice}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                        onChange={value => this.handleChange(value, 'nonBindBusinessProposalTotalPrice')}
                                    />
                                </div>
                            </div>
                        }
                        {
                            evaluateStatus == 'STATE_FOR_RESTART_APPROVAL' && <div className="content_item" >
                                <div className="item_left">{asterisk}备注说明：</div>
                                <div className="item_right">
                                    <Input
                                        placeholder='请输入'
                                        style={{ width: 200 }}
                                        value={businessProposalRemark}
                                        onChange={e => this.handleChange(e.target.value, 'businessProposalRemark')}
                                    />
                                </div>
                            </div>
                        }
                        {
                            evaluateStatus == 'STATE_FOR_RESTART_APPROVAL' && <div className="content_item" >
                                <div className="item_left">底价测算文档：</div>
                                <div className="item_right">
                                    <Upload
                                        data={{
                                            curUserId: sessionStorage.userId,
                                            curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                        }}
                                        fileList={fileList}
                                        beforeUpload={this.beforeUpload}
                                        onRemove={this.handleRemove}
                                        headers={xToken}
                                    >
                                        <Button style={{ width: 80 }}>选择文件</Button>
                                    </Upload>
                                </div>
                            </div>
                        }
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default ConfirmTotalPiceModal;


// WEBPACK FOOTER //
// ./src/components/businessOffer/businessOfferRecord/ConfirmTotalPiceModal.js